import React, { useEffect, useState } from 'react'
import { Tabs } from 'antd'
import { useParams, useNavigate, useLocation } from 'react-router-dom'
import { Helmet } from 'react-helmet';
import { checkMenu, getChildPath, checkLogin } from '@/utils'
import UserInfo from './components/userInfo'
import HouseList from './components/houseList'
import SearchLog from './components/searchLog'
import RoomTypeList from './components/roomTypeList'
import RoomList from './components/roomList'
import AddressList from './components/addressList'

export default function Detail() {
  const [count, setCount] = useState(0)
  const [tabsKey, setTabsKey] = useState(0)
  const [tabsList, setTabsList] = useState([])
  const pageObj = {
    houselist: <HouseList />,
    searchlog: <SearchLog />,
    roomtypelist: <RoomTypeList />,
    roomlist: <RoomList />,
    addresslist: <AddressList />,
  }

  const location = useLocation()
  const navigate = useNavigate()
  const params = useParams()
  const userId = params.userid
  //  tab切换
  const changeTabs = key => {
    let path = '/managecenter/user/' + tabsList[key].name + '/' + userId
    navigate(path)
    setCount(count + 1)
  }

  const toLinkTabs = url => {
    navigate(url)
    setCount(count + 1)
  }

  useEffect(() => {
    if(!checkMenu(location.pathname.replace('/' + userId, ''))) {
      navigate('/managecenter/404')
      return
    }
    if(!checkLogin()) {
      setTimeout(() => {
        navigate('/')
      }, 2000)
      return
    }
    let pathList = getChildPath('/managecenter/user/detail') || []
    let tabs = [
      {
        key: 0,
        label: '概况',
        name: 'detail',
        children: <UserInfo changeLinkTabs={toLinkTabs} />
      }
    ]
    let key = 0
    pathList?.forEach((item, index) => {
      //  检查url是否在权限中
      if (!checkMenu(item.path)) {
        return
      }

      let name = item.path.replace('/managecenter/user/', '')
      tabs.push({
        key: index + 1,
        label: item.name,
        name,
        children: pageObj[name]
      })

      params.name === name && (key = index + 1)
    })
    setTabsList(tabs)
    setTabsKey(key)

    setTabsKey(key)
    //getDetail()
  }, [count])
  return (
    <div>
      <Helmet>
        <title>{'用户画像-' + process.env.REACT_APP_HTML_TITLE}</title>
      </Helmet>
      <div className="pageTitle">
        <div className="pageTitle-name">用户画像</div>
      </div>
      <div className="tabs">
        <Tabs activeKey={tabsKey} items={tabsList} onTabClick={changeTabs} />
      </div>
    </div>
  )
}
